export const environment = {
  production: false,
  ambiente: 'PROD',

  api: 'https://secretariadigitalapi.uninter.com/',
  webUrl: 'https://secretariadigital.uninter.com/',

  apiAccount: 'https://accountapi.uninter.com/',
  webAccount: 'https://account.uninter.com/',

  tokenRSAApi: 'https://tokenapi.uninter.com/api/tokenRSA',
  contratoDigital: 'https://contratodigital.uninter.com/',
  pagamentos: 'https://pagamentos.uninter.com',
};